import { JSEncrypt } from 'jsencrypt'
import { getPublicKey } from '@/api/captcha'

// RSA 公钥缓存
let cachedPublicKey: string | null = null

/**
 * 获取 RSA 公钥
 */
export async function getRSAPublicKey(): Promise<string> {
  if (cachedPublicKey) {
    return cachedPublicKey
  }

  const resp = await getPublicKey()
  cachedPublicKey = resp.publicKey
  if (!cachedPublicKey) {
    throw new Error('获取公钥失败')
  }
  return cachedPublicKey
}

/**
 * 使用 RSA 公钥加密数据
 * 加密失败时会自动刷新公钥重试一次
 */
export async function encryptWithPublicKey(data: string): Promise<string> {
  try {
    return await doEncrypt(data)
  } catch (error) {
    // 加密失败，可能是公钥过期，清除缓存重试
    clearPublicKeyCache()
    try {
      return await doEncrypt(data)
    } catch (retryError) {
      throw new Error('密码加密失败，请刷新页面重试')
    }
  }
}

/**
 * 执行加密操作
 */
async function doEncrypt(data: string): Promise<string> {
  const publicKeyBase64 = await getRSAPublicKey()

  // 解码 Base64 获取 PEM 格式公钥
  const publicKeyPem = atob(publicKeyBase64)

  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKeyPem)

  const encrypted = encrypt.encrypt(data)
  if (!encrypted) {
    throw new Error('加密失败')
  }

  return encrypted
}

/**
 * 清除缓存的公钥（用于重新获取）
 */
export function clearPublicKeyCache(): void {
  cachedPublicKey = null
}
